import {map} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {Observable} from "rxjs";
import {environment} from '../../environments/environment';

declare var jquery: any;
declare var $: any;
declare var swal: any;

@Injectable()
export class MyHttpInterceptor implements HttpInterceptor {
  constructor(private _router: Router) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let token: string = localStorage.getItem('token') ;
    token = (token && token.toString().trim() === 'null') ? null : token;
    request = request.clone({headers: request.headers.set('Accept', 'application/json, text/plain, */*')});
    request = request.clone({headers: request.headers.set('Content-Type', 'application/json')});
    if (token) {
      request = request.clone({headers: request.headers.set('token2X', token)});
    }
    request = request.clone({headers: request.headers.set('client', environment.general.nameMultiClient)});
    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          if (event.status === 200) {
            const timeExpiration: number = Number(event.headers.get('token-expiration')) + Number(new Date().getTime());
            localStorage.setItem('token', event.headers.get('token2X'));
            localStorage.setItem('token-expiration', JSON.stringify(timeExpiration));
          }
        }
        return event;
      }));
  }
}
